import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { NewDataAdd, NewDataUpd, NewsStateData } from './types';

const initialState: NewsStateData = {
	data: { error: '', data: [] },
	loading: false,
	error: '',
};

export const fetchGetNews = createAsyncThunk('api/fetchGetNews', () => api.fetchGetNews());
export const fetchAddNew = createAsyncThunk('api/fetchAddNew', ({ token, title, text, isHidden }: NewDataAdd) =>
	api.fetchAddNew({ token, title, text, isHidden }),
);
export const fetchUpdNew = createAsyncThunk('api/fetchUpdNew', ({ token, id, title, text, isHidden }: NewDataUpd) =>
	api.fetchUpdNew({ token, id, title, text, isHidden }),
);
export const fetchDeleteNew = createAsyncThunk('api/fetchDeleteNew', ({ id, token }: { id: string; token: string }) =>
	api.fetchDeleteNew({ id, token }),
);

const newsSlice = createSlice({
	name: 'news',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchGetNews.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchGetNews.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchGetNews.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			})
			.addCase(fetchAddNew.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchAddNew.fulfilled, (state) => {
				state.loading = false;
				state.error = '';
			})
			.addCase(fetchAddNew.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			})
			.addCase(fetchUpdNew.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchUpdNew.fulfilled, (state, action) => {
				state.loading = false;
				if (Array.isArray(state.data.data) && action.payload && !action.payload.error) {
					const index = state.data.data.findIndex((item) => item.id === action.payload.id);
					if (index !== -1) {
						state.data.data[index] = action.payload;
					}
				}
				state.error = '';
			})
			.addCase(fetchUpdNew.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			})
			.addCase(fetchDeleteNew.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchDeleteNew.fulfilled, (state, action) => {
				state.loading = false;
				if (Array.isArray(state.data.data) && action.payload && !action.payload.error) {
					state.data.data = state.data.data.filter((item) => item.id !== action.payload.id);
				}

				state.error = '';
			})
			.addCase(fetchDeleteNew.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка при удалении';
			});
	},
});

export default newsSlice.reducer;
